import Vue from 'vue'
import App from './App.vue'
import VModal from 'vue-js-modal'
import icons from './icons';

import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "UA-180155792-1" }
});

Vue.config.productionTip = false;
Vue.use(VModal, { dialog: true });
icons.use();

new Vue({
  render: h => h(App),
}).$mount('#app');
